import React from "react";
import animation1 from "./animation_ln2xnag4.mp4";
import animation2 from './animation_ln376eq3.mp4';
import "./ido.css";
import css from '../../images/css-icon.svg'
import javascript from '../../images/javascript-programming-language-icon.svg';
import react from '../../images/react-js-icon.svg';
import nodde from '../../images/node-js-icon.svg';
import npmm from '../../images/npm-icon.png'
import yarn from '../../images/yarn-package-manager-icon.svg'
import mongo from '../../images/mongodb-icon.svg'
import aws from '../../images/aws-icon.svg'

export default function Ido() {
  return (
    <div>
      <div className="hed">

      <h1 className="whatido">What I Do ??</h1>
      </div>

      <div className="ido">
        <div className="left-side">
          <video
            className="videofile"
            width="440"
            height="360"
            autoPlay
            muted
            loop
          >
            <source src={animation1} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="textt">
          <h1>Full Stack Developer ! </h1>
          <br/>
          <div className="logoo">
            <img src="https://www.w3.org/html/logo/badge/html5-badge-h-solo.png" width="63" height="64" alt="HTML5 Powered" title="HTML5 Powered"/>
            <img src={css} width="63" height="64" alt="css-icon" />
            <img src={javascript} width="63" height="64" alt="javascript"/>
            <img src={react} width="63" height="64" alt="react"/>
            <img src={nodde} width="63" height="64" alt="node" />
            <img src={npmm} width="73" height="64" alt="npm" />
            <img src={yarn} width="73" height="64" alt="yarn" />
            <img src={mongo} width="73" height="64" alt="mongodb" />
            <img src={aws} width="73" height="64" alt="aws" />


          </div>

          <p style={{color:'rgb(127, 141, 170)'}}>⚡ Building responsive website front end using React-Redux</p>
          <p style={{color:'rgb(127, 141, 170)'}}>⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin</p>
          <p style={{color:'rgb(127, 141, 170)'}}>⚡ Creating application backend in Node, Express &amp; Flask</p>
        </div>
      </div>
      <div className="ido" style={{marginTop:'20px'}}>
        <div className="left-side">
          <video
            className="videofile"
            width="440"
            height="360"
            autoPlay
            muted
            loop
          >
            <source src={animation2} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="textt">
          <h1>Cloud Infra-Architecture !</h1>
          <br/>
          <div className="logoo">
            <img src={nodde} width="63" height="64" alt="node" />
            <img src={mongo} width="73" height="64" alt="mongodb" />
            <img src={aws} width="73" height="64" alt="aws" />


          </div>

          <p style={{color:'rgb(127, 141, 170)'}}>⚡ Experience working on multiple cloud platforms</p>
          <p style={{color:'rgb(127, 141, 170)'}}>⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases</p>
          <p style={{color:'rgb(127, 141, 170)'}}>⚡  Deploying deep learning models on cloud to use on mobile devices</p>
        </div>

        
      </div>
    </div>
  );
}
